import React, { useState } from 'react'
import { Formik } from 'formik'
import * as yup from 'yup'
import { DatiAccesso, DatiPersonali, TuoBambino } from './steps/index'
import { IinitialVaues } from './FormRegistrazione.interfaces'

const validationSchema = yup.object().shape({
  dati_accesso: yup.object().shape({
    nome: yup.string().nullable().required(),
    cognome: yup.string().nullable().required(),
    email: yup.string().email("Il formato dell'email dev'essere valido").nullable().required(),
    password: yup.string().min(6, 'Minimo 6 caratteri').nullable().required(),
  }),
  dati_personali: yup.object().shape({
    sono: yup.string().required().nullable(),
    data_nascita: yup.object().shape({
      giorno: yup.number().required().nullable(),
      mese: yup.number().required().nullable(),
      anno: yup.number().required().nullable(),
    }),
    cellulare: yup.number().nullable(),
  }),
  tuo_bambino: yup.object().shape({
    nome_bambino: yup.string().required().nullable(),
    data_bambino: yup.object().shape({
      giorno: yup.number().required().nullable(),
      mese: yup.number().required().nullable(),
      anno: yup.number().required().nullable(),
    }),
    sesso_bambino: yup.string().required().nullable(),
  }),

  privacy: yup.boolean().required().nullable(),
})

const RenderSteps = ({ steps, setSteps, formik }) => {
  switch (steps) {
    case 0:
      return <DatiAccesso formik={formik} setSteps={setSteps} />
    case 1:
      return <DatiPersonali formik={formik} setSteps={setSteps} />
    case 2:
      return <TuoBambino formik={formik} setSteps={setSteps} />
    default:
  }
}

const FormRegistrazione = ({ initialStep }: number | any) => {
  const [steps, setSteps] = useState(initialStep || 0)

  const initialValues: IinitialVaues = {
    dati_accesso: {
      nome: null,
      cognome: null,
      email: null,
      password: null,
    },
    dati_personali: {
      data_nascita: {
        giorno: null,
        mese: null,
        anno: null,
      },
      cellulare: null,
      sono: null,
    },
    tuo_bambino: {
      data_bambino: {
        giorno: null,
        mese: null,
        anno: null,
      },
      sesso_bambino: null,
      nome_bambino: null,
    },
    privacy: null,
  }

  return (
    <div>
      <Formik
        isInitialValid={false}
        validateOnBlur
        validateOnChange
        validationSchema={validationSchema}
        onSubmit={(values) => console.log('Registrazione', values)}
        initialValues={initialValues}
      >
        {(props) => <RenderSteps formik={props} steps={steps} setSteps={setSteps} />}
      </Formik>
    </div>
  )
}

export default FormRegistrazione
